import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import {
  TextField
} from "@material-ui/core";
import {
  dateTimeReportFormatter
} from "../../fomatters/DateFormatter";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import ReportByGame from "../ReportByGame";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function GameStarted() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [sport, setSport] = useState("");
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    addEmpty: true,
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={""}
        />
      </div>
      <ReportByGame
        title="Game Started Report"
        getUrl={() => "/Reports/Report_Game_Started_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Sport: sport,
        })}
        getProcess={(sport, values) => {
          switch (sport) {
            case "tnt":
              return [values?.[0], ...values].map(
                (
                  {
                    Id,
                    idSport,
                    gameDateTime,
                    homeName,
                    visitorName,
                    gradedDate,
                    periodDescription
                  },
                  index
                ) => {
                  if (index === 0) {
                    return {
                      Id: `${Id}V`,
                      sport: idSport,
                      date: gameDateTime,
                      team: visitorName,
                      period: periodDescription,
                      gradedDate,
                    };
                  } else {
                    return {
                      Id: `${Id}H`,
                      sport: "",
                      date: "",
                      team: homeName,
                      period: "",
                      gradedDate: "",
                    };
                  }
                }
              );
            default:
              const {
                Id,
                idSport,
                gameDateTime,
                homeName,
                visitorName,
                gradedDate,
                periodDescription
              } = values?.[0];
              return [
                {
                  Id: `${Id}V`,
                  sport: idSport,
                  date: gameDateTime,
                  team: visitorName,
                  period: periodDescription,
                  gradedDate,
                },
                {
                  Id: `${Id}H`,
                  sport: "",
                  date: "",
                  team: homeName,
                  period: "",
                  gradedDate: "",
                },
              ];
          }
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="sport">
          Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="date"
          dataFormat={dateTimeReportFormatter}
        >
          Game Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="team">
          Visitor / Home
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="period">
          Period
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="gradedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Graded
        </TableHeaderColumn>
      </ReportByGame>
    </div>
  );
}

export default GameStarted;
